var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CoachingCategories',{staticStyle:{"margin-bottom":"18px"},attrs:{"category-loading":_vm.processLoading,"categories":_vm.formattedCategory}}),_c('CategoryEditor',{attrs:{"categories":_vm.categories}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }